
<template>
<div class="container  pb-5">
    <div class="text-center">


        


    </div>
</div>
</template>


<style lang="scss">
@import '~@/styles/home.css';
</style>

<script>

import { initializeApp } from "firebase/app";
import { getDatabase,ref,set } from "firebase/database";

const config = {

    apiKey: "AIzaSyBILrykfyUwQ7jA92zWjAwq3vK1PzNHBCQ",
    authDomain: "escapist-france-a53c2.firebaseapp.com",
    databaseURL: " https://escapist-france-a53c2-default-rtdb.firebaseio.com",
    projectId: "escapist-france-a53c2",
    storageBucket: "escapist-france-a53c2.appspot.com",
    messagingSenderId: "135622445342",
    appId: "1:135622445342:web:74db1f2cad55e66e43a10f"

};

const f_app = initializeApp(config);
const db = getDatabase(f_app);
//const dbRef = ref(db);



export default {

    components:{
        //HeaderBar
    },

    data(){
        return {
        
        }
    },

    methods:{
        randName(){
            var result           = '';
            var characters       = 'abcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for ( var i = 0; i < 12; i++ ) {
                result += characters.charAt(Math.floor(Math.random() * 
            charactersLength));
            }
            return result;
        },

        addGame(){
            

            set(ref(db, this.randName()), {
                adminPassword: "dasdasd",
                gameId: this.randName(),

            });


        },
        
    },

    mounted () {
        
    },

    
};


</script>

